<template>
  <div id="Continue">
    <div class="Continuebox1">
      <div class="Continuebox2">
        <div class="btn_close">
          <img src="./img/icon_img21.png"
               @click="close"
               class="close" alt=""/>
        </div>
        <div class="bg_url">
          <img src="./img/icon_img52.png"
               class="bg_img" alt=""/>
        </div>
        <div class="title1">
          高级图片编辑功能上线啦！
        </div>
        <div class="title2">
          <div>注意</div>
          高级图片功能是MJ绘画独家研发功能，但凡你见到的下一家，绝对是抄袭我们的（律师会及时存证），请注意防骗！
        </div>
<!--        <div class="title3">-->
<!--          视频演示-->
<!--        </div>-->
        <div class="video_box">
          <video class="shipin"
                 controls
                 autoplay
                 src="https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/ad/ad_mj_edit.mp4">
          </video>
        </div>
        <div class="Continue_btn">
          <div class="" @click="close">
            好的，我知道了
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {

  },
  methods: {
    close() {
      console.log('关闭')
      this.$store.commit('setShow_Continue', false)
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#Continue {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .Continuebox1 {
    position: relative;
    width: 100%;
    height: 100%;

    .Continuebox2 {
      width: 1200px;
      //max-width: 1200px;
      //min-width: 1000px;
      //height: 500px;
      background: white;
      position: absolute;
      padding: 20px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .btn_close {
        width: 25px;
        height: 25px;
        background: black;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 10px;
        right: 10px;

        .close {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }
      }
      .bg_url{
        position: absolute;
        top: 10px;
        right: 40px;
        z-index: -1;
        opacity: .5;
        img{
          width: 100px;
          height: auto;
        }
      }

      .title1 {
        font-size: 28px;
        color: black;
        font-weight: 700;
        line-height: 1;
      }

      .title2 {
        color: #999999;
        font-size: 14px;
        display: flex;
        margin: 14px 0;
        line-height: 1;

        div {
          font-size: 12px;
          color: white;
          background: black;
          //padding: 1px 2px;
          border-radius: 3px;
          margin-right: 4px;
          padding: 2px 3px;


        }
      }

      .title3 {
        color: black;
        font-size: 14px;
        font-weight: 700;
        border-top: 2px solid #000;
        padding: 5px 0 0 0;
        display: inline-block; /* 关键：让宽度只适应内容 */
      }

      .video_box {
        width: 100%;
        //height: 400px;
        border-radius: 4px;
        //background: black;
        color: white;
        margin: 15px 0 20px 0;
        overflow: hidden;
        display: flex;
        .shipin{
          width: 100%;
          height: auto;
        }
      }

      .Continue_btn {

        display: flex;
        justify-content: flex-end;

        div {
          padding: 8px 15px;
          border-radius: 4px;
          background: black;
          color: white;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }


}

</style>